export default __webpack_public_path__ + "static/media/icon_story_7.86cbae18.svg";